import { useEffect, useRef, useState } from "react";

export default function GuaranteeSection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-8 lg:px-12">
        <div
          className={`rounded-2xl border border-background-200/70 bg-background-100 p-8 md:p-12 text-center card-hover-lift transition-all duration-600 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"
          }`}
          style={{ transitionTimingFunction: "cubic-bezier(0.22, 0.61, 0.36, 1)" }}
        >
          <div className="w-18 h-18 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-6">
            <i className="ri-shield-check-line text-3xl" />
          </div>
          <h3 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            180-Day Risk-Free Guarantee
          </h3>
          <p className="text-foreground-700 text-xl leading-relaxed max-w-2xl mx-auto mb-6">
            Six full months to evaluate Joint Genesis. If it isn&apos;t right for you,
            request a refund directly through the official source.
          </p>
          <div className="flex items-center justify-center gap-2 text-accent-500 font-semibold text-2xl">
            <span>100%</span>
            <span className="text-foreground-400">|</span>
            <span>Risk Free</span>
          </div>
        </div>
      </div>
    </section>
  );
}